<template>
  <div>
    <v-filter>
      <el-form slot="filter" :model="filter" inline @submit.native.prevent="loadList()">
        <el-form-item label="姓名">
          <el-input v-model="filter.name"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button type="primary" @click="add()">新增分组</el-button>
        <el-button type="primary" @click="add('permission')">新增权限</el-button>
      </div>
    </v-filter>

    <el-tabs v-model="filter.platform" @tab-click="loadList()">
      <el-tab-pane name="merchant" label="PC权限"></el-tab-pane>
      <el-tab-pane name="merchant_app" label="APP权限"></el-tab-pane>
    </el-tabs>

    <el-table
     stripe
     row-key="id"
     :data="list"
     :tree-props="{children: 'items'}">
      <el-table-column prop="name" label="名称"></el-table-column>
      <el-table-column prop="key" label="KEY">
        <span slot-scope="scope">{{ scope.row.key || '-' }}</span>
      </el-table-column>
      <el-table-column width="150px">
        <div v-if="scope.row.id !== 'other'" slot-scope="scope">
          <el-button v-if="!scope.row.key" type="text" @click="add('permission', scope.row.id)">创建权限</el-button>
          <el-button type="text" @click="edit(scope.row)">编辑</el-button>
          <el-button type="text" @click="del(scope.row)">删除</el-button>
        </div>
      </el-table-column>
    </el-table>
    
    <v-page v-model="filter" @change="loadList"></v-page>

    <v-drawer :title="`${!form.id ? '新增' : '编辑'}权限分组`" :visible.sync="visible">
      <el-form :model="form" ref="form" :rules="rules" label-width="120px">
        <el-form-item label="分组名称" prop="group_name">
          <el-input v-model="form.group_name"></el-input>
        </el-form-item>

        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio v-for="(val, key) in TYPE" :key="key" :label="Number(key)">{{ val }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="权限平台" prop="platform">
          <el-radio-group v-model="form.platform">
            <el-radio v-for="(val, key) in PLATFORM" :key="key" :label="key">{{ val }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="commit">提交</el-button>
        </el-form-item>
      </el-form>
    </v-drawer>

    <v-drawer :title="`${!form.id ? '新增' : '编辑'}权限`" :visible.sync="permission_visible">
      <el-form :model="permission_form" ref="permission_form" :rules="permission_rules" label-width="120px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="permission_form.name"></el-input>
        </el-form-item>

        <el-form-item label="KEY" prop="key">
          <el-input v-model="permission_form.key"></el-input>
        </el-form-item>

        <el-form-item label="路由" prop="endpoint">
          <el-input v-model="permission_form.endpoint"></el-input>
        </el-form-item>

        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="permission_form.type">
            <el-radio v-for="(val, key) in TYPE" :key="key" :label="Number(key)">{{ val }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="权限平台" prop="platform">
          <el-radio-group v-model="permission_form.platform">
            <el-radio v-for="(val, key) in PLATFORM" :key="key" :label="key">{{ val }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="commitPermission">提交</el-button>
        </el-form-item>
      </el-form>
    </v-drawer>
  </div>
</template>

<script>
export default {
  name: 'Permissions',
  data() {
    const TYPE = {
      // 100: 'API权限',
      200: '菜单权限'
    }

    const PLATFORM = {
      merchant: '商户PC',
      merchant_app: '商户APP'
    }

    return {
      TYPE,
      PLATFORM,
      visible: false,
      permission_visible: false,

      filter: {
        page: 1,
        page_size: 10,
        type: 200,
        platform: 'merchant'
      },

      list: [],
      total: 0,

      form: {
        type: 200,
        platform: 'merchant'
      },
      rules: {
        group_name: [{ required: true, message: '必填！', trigger: 'blur' }]
      },

      permission_form: {
        type: 200,
        platform: 'merchant'
      },
      permission_rules: {
        name: [{ required: true, message: '必填！', trigger: 'blur' }],
        key: [{ required: true, message: '必填！', trigger: 'blur' }],
        endpoint: [{ required: true, message: '必填！', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.$init(['form', 'permission_form'], () => {
      this.loadList()
    })
  },
  methods: {
    add(type = 'group', permission_group_id) {
      if (type === 'group') {
        this.editGroup()
      } else {
        this.editPermisson(undefined, permission_group_id)
      }
    },

    edit(row) {
      if (row.items) {
        this.editGroup(row)
      } else {
        this.editPermisson(row)
      }
    },

    editGroup(row = {}) {
      this.$reset(['form'], () => {
        if (row.id) {
          this.$sets(this.form, { group_name: row.name, ...row })
        }
        this.visible = true
      })
    },

    editPermisson(row = {}, permission_group_id) {
      this.$reset(['permission_form'], () => {
        if (permission_group_id) {
          this.$sets(this.permission_form, { permission_group_id })
        }
        if (row.id) {
          this.$sets(this.permission_form, row)
        }
        this.permission_visible = true
      })
    },

    async del(row) {
      const { id, items } = row
      await this.$confirm('确认删除？')
      if (items) {
        await this.$api.setting.permission.delPermissionGroups(id)
      } else {
        await this.$api.setting.permission.delPermissions(id)
      }
      this.$message.success('删除成功！')
      this.loadList()
    },

    async loadList(page = 1) {
      this.filter.page = page
      const { data } = await this.$api.setting.permission.getPermissions(this.filter)
      this.list = data.items
      this.filter.total = data.totalItems
    },

    async commit() {
      await this.$validate(this.$refs.form)
      const params = { ...this.form }
      if (!params.id) {
        await this.$api.setting.permission.postPermissionGroups(params)
      } else {
        await this.$api.setting.permission.gutPermissionGroups(params.id, params)
      }

      await this.loadList()

      this.$message.success('保存成功！')
      this.visible = false
    },

    async commitPermission() {
      await this.$validate(this.$refs.permission_form)
      const params = { ...this.permission_form }
      if (!params.id) {
        await this.$api.setting.permission.postPermissions(params)
      } else {
        await this.$api.setting.permission.putPermissions(params.id, params)
      }

      await this.loadList()

      this.$message.success('保存成功！')
      this.permission_visible = false
    }
  }
}
</script>
